<template>
  <div id="default-layout">
    <sidebar-nav />

    <navbar-page />

    <slot />

    <footer-basic />
  </div>
</template>

<script>
import mixins from '../../mixins/mixins';
import NavbarPage from '../../components/navbar-page.vue';
import SidebarNav from '../../components/navbar/sidebar-nav.vue';
import FooterPage from '../../components/footer-page.vue';
import FooterBasic from '../../components/footer-basic.vue';

export default {
  components: {
    NavbarPage,
    SidebarNav,
    FooterPage,
    FooterBasic,
  },
  mixins: [mixins],
};
</script>
